import { featureFlags } from "~/helpers/feature-helpers";

export default defineNuxtRouteMiddleware((to) => {
  const app = useNuxtApp();

  function isRouteSupported(route: string) {
    const flags = featureFlags(app).filter((f) => f.routes.includes(route));

    if (flags.length == 0) {
      return true;
    } else {
      return flags.some((f) => f.active);
    }
  }

  if (!isRouteSupported(to.name as string)) navigateTo("/");
});
